// DupsterCarousel.js
import React from 'react';
import Slider from 'react-slick';
import './DumpsterCarousel.css'; // Optional if you want custom styling

function DumpsterCarousel() {
  // Slider settings: adjust to your preference
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,         // optional
    autoplaySpeed: 3000,    // optional
    arrows: true,           // show next/prev arrows
  };

  return (
    <div className="dumpster-carousel">
      <Slider {...settings}>
        {/* Replace with your actual image paths and alt text */}
        <div>
            <img src={`${process.env.PUBLIC_URL}/images/green_garbage.jpg`} alt="Garbage 1" />
        </div>
        <div>
            <img src={`${process.env.PUBLIC_URL}/images/garbage_rental.jpeg`} alt="Garbage 2" />
        </div>
        {/* Add more slides as needed */}
      </Slider>
    </div>
  );
}

export default DumpsterCarousel;
